export default "__VITE_ASSET__AYILPmDN__"